import { Dispatch } from 'redux';

import { Api } from '../../api';
import { AppState } from '../../store/models/app-state';
import { NotificationSetting } from '../models/notification-setting';

export const NOTIFICATIONS_REQUEST = 'NOTIFICATIONS_REQUEST';
export const NOTIFICATIONS_RECEIVED = 'NOTIFICATIONS_RECEIVED';
export const NOTIFICATION_CREATE = 'NOTIFICATION_CREATE';
export const NOTIFICATION_DELETE = 'NOTIFICATION_DELETE';

const receiveNotifications = (notifications: NotificationSetting[]) => ({
    type: NOTIFICATIONS_RECEIVED,
    notifications,
});

export const fetchNotifications = () => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }) => {
        dispatch({ type: NOTIFICATIONS_REQUEST });

        const response = await api.notifications.getNotifications();

        if (response.success) {
            dispatch(receiveNotifications(response.result));
        }
    };
};

export const createNotification = (notification: NotificationSetting) => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }) => {
        dispatch({ type: NOTIFICATIONS_REQUEST });

        const requestNotification: NotificationSetting = {
            notificationOrigin: notification.notificationOrigin,
            recipientEmail: notification.recipientEmail || null,
        };

        const response = await api.notifications.createNotification(requestNotification);
        if (response.success) {
            dispatch({ type: NOTIFICATION_CREATE, notification: response.result });
        }
    };
};

export const deleteNotification = (id: number) => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }) => {
        dispatch({ type: NOTIFICATIONS_REQUEST });

        const response = await api.notifications.deleteNotification(id);
        if (response.success) {
            dispatch({ type: NOTIFICATION_DELETE, id });
        }
    };
};
